import { useEffect, useRef } from 'react';

const useObserveSize = (elementRefs, callback) => {
    const observer = useRef(null);

    useEffect(() => {
        if (!elementRefs) return;

        const elements = Array.isArray(elementRefs) ? elementRefs : [elementRefs];

        observer.current = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                callback(entry.target);
            });
        });

        elements.forEach((element) => {
            if (element) {
                observer.current.observe(element);
                callback(element);
            }
        });

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [elementRefs, callback]);
}

export default useObserveSize;